export default __webpack_public_path__ + "static/media/LogoFarm.54701576.png";